import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { hubspotService } from '../services/hubspotService'

export function useHubSpotPageTracking (): void {
  const location = useLocation()

  useEffect(() => {
    hubspotService.trackPageView(location.pathname + location.search)
  }, [location.pathname, location.search])
}
